import React, { useContext } from "react";
import { observer } from "mobx-react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { THEME_SETTINGS } from "@theme-settings";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { TSection } from "@data-types/offer/live/Section";
import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";

export const PrimaryNavLinks = observer(function PrimaryNavLinks(props: {
	culture: string;
}) {
	const { culture } = props;

	const liveEventMenuViewStore = useContext(LiveEventSideMenuContext);

	const {
		liveCount,
		liveEventsFromMyBets: {
			count: playedLiveEventsCount,
			isEnabled: isPlayedLiveEventsEnabled,
		},
		liveFavoritesCounter,
		liveFavoriteTournamentsCount,
	} = liveEventMenuViewStore;

	const { t } = useTranslation();

	return (
		<li className="nav--secondary__item nav--live__item">
			<NavLink
				className="nav--secondary__link"
				activeClassName="is-expanded"
				exact
				to={`/${culture}/${DefaultPath.LIVE}`}
			>
				<div className="nav--secondary__icon">
					{liveCount > 0 && (
						<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
							{liveCount}
						</span>
					)}
					<i className="nav--secondary__icon u-icon u-icon--lrg u-icon--all" />
				</div>

				<div className="nav--secondary__title">
					{t<string>("LIVE.SIDEMENU.ALL")}
				</div>
			</NavLink>
			{isPlayedLiveEventsEnabled && playedLiveEventsCount > 0 && (
				<NavLink
					className="nav--secondary__link"
					activeClassName="is-expanded"
					exact
					to={`/${culture}/live/played-events`}
				>
					<div className="nav--secondary__icon">
						{playedLiveEventsCount > 0 && (
							<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
								{playedLiveEventsCount}
							</span>
						)}

						<i className="nav--secondary__icon u-icon u-icon--lrg u-icon--played-events" />
					</div>

					<div className="nav--secondary__title">
						{t<string>("LIVE.SIDEMENU.PLAYED_EVENTS")}
					</div>
				</NavLink>
			)}
			{THEME_SETTINGS.features.isFavoritesEnabled &&
				liveFavoritesCounter > 0 && (
					<NavLink
						className="nav--secondary__link"
						activeClassName="is-expanded"
						exact
						to={`/${culture}/live/${TSection.MyFavoritesEvents}`}
					>
						<div className="nav--secondary__icon">
							{liveFavoritesCounter > 0 && (
								<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
									{liveFavoritesCounter}
								</span>
							)}

							<i className="nav--secondary__icon u-icon u-icon--lrg u-icon--favorites" />
						</div>

						<div className="nav--secondary__title">
							{t<string>("SPORTS_MENU.MY_FAVORITES.MY_EVENTS")}
						</div>
					</NavLink>
				)}
			{THEME_SETTINGS.features.isFavoritesEnabled &&
				liveFavoriteTournamentsCount > 0 && (
					<NavLink
						className="nav--secondary__link"
						activeClassName="is-expanded"
						exact
						to={`/${culture}/live/${TSection.MyFavoritesTournaments}`}
					>
						<div className="nav--secondary__icon">
							<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
								{liveFavoriteTournamentsCount}
							</span>

							<i className="nav--secondary__icon u-icon u-icon--lrg u-icon--favorite-tournaments--filled" />
						</div>

						<div className="nav--secondary__title">
							{t<string>("SPORTS_MENU.MY_FAVORITES.MY_LEAGUES")}
						</div>
					</NavLink>
				)}
		</li>
	);
});
